import { css } from '@emotion/react';
import { FormControl, FormLabel, Grid, MenuItem, Select } from '@material-ui/core';
import DateControl from 'components/shared/FormControls/DateControl';
import { useColors } from 'hooks/useColors';
import { required } from 'lib/form';
import { i18n } from 'lib/i18n';
import { Field as FinalField } from 'react-final-form';
import { IColors, useModal } from '@bondsports/utils';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { dialogZIndex } from 'styles/dialog';
import { setOpacity } from 'styles/utils';
import { GenderEnum } from '@bondsports/types';
import { EDateFormats, EDates, EDurations } from 'types/times';

const userFormControlCss = css`
	.MuiFormLabel-root {
		padding: 8px 0;
	}

	&.MuiFormControl-root {
		padding: 10px 0;
	}

	width: 100%;
`;

const dateControlCss = (colors: IColors) => css`
	background-color: ${colors.bg_background_primary};
	height: 40px;

	.MuiInputBase-input {
		padding: 12px;
	}
`;

const selectCss = (colors: IColors) => css`
	background-color: ${colors.bg_background_primary};
	text-indent: 12px;
	height: 40px;

	.MuiSelect-icon {
		background-color: ${setOpacity(colors.bg_text_primary || '', 0.37)};
		top: 0;
		height: 100%;
		color: ${colors.tx_white};
		width: 40px;
		border-radius: 2px;
		font-size: 1rem;
	}

	&.MuiInput-formControl {
		margin-top: 0;
	}
`;

export const GenderAndBirthDate = () => {
	const { colors } = useColors();
	const { zIndex } = useModal();

	return (
		<div data-aid="GenderAndBirthDate" style={{ gap: 10, display: 'flex', width: '100%' }}>
			<FinalField name="gender" validate={required}>
				{({ input }) => (
					<Grid item xs={6} data-aid="gender">
						<FormControl css={userFormControlCss}>
							<FormLabel htmlFor="userGender">{i18n.user.profile.gender}</FormLabel>
							<Select data-testid="GenderAndBirthDate-618A0A" 
								disableUnderline
								css={[selectCss(colors), dialogZIndex(zIndex)]}
								IconComponent={ExpandMoreIcon}
								{...input}
							>
								{Object.entries(i18n.forms.gender).map(([key, value]) => (
									<MenuItem key={key} value={GenderEnum[key as keyof typeof GenderEnum]}>
										{value}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
				)}
			</FinalField>
			<FinalField name="birthDate" validate={required} displayEmpty>
				{({ input }) => (
					<Grid item xs={6} data-aid="birthDate">
						<FormControl fullWidth css={userFormControlCss}>
							<FormLabel htmlFor="birthDate">{i18n.user.profile.birthDate}</FormLabel>
							<DateControl
								{...input}
								value={input.value as Date}
								name="birthDate"
								format={EDateFormats.SLASHED_MM_dd_YYYY}
								openTo="year"
								views={[EDurations.YEAR, EDurations.MONTH, EDates.DATE]}
								disableFuture
								InputProps={{
									disableUnderline: true,
								}}
								css={dateControlCss(colors)}
							/>
						</FormControl>
					</Grid>
				)}
			</FinalField>
		</div>
	);
};
